<script lang="ts">
	import DefaultButton from '../../../../basic/buttons/DefaultButton.svelte';
	import DefaultTextInput from '../../../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../../../basic/input/InputLabel.svelte';
	import Modal from '../../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../../basic/modal/ModalHeader.svelte';
	import { addNotification } from '../../../../notification/Notificationstore';
	import { handleStoreError } from '../../../../stores/GeneralStore';
	import { type SettingPaymentPeriodStore } from '../../../../stores/SettingPaymentPeriodsStore.svelte';
	import { _ } from 'svelte-i18n';

	interface Props {
		store: SettingPaymentPeriodStore;
		onModalClose: () => void;
	}

	let { store, onModalClose }: Props = $props();

	let defaultName: string = $state('');

	async function createSettingDocumentType() {
		if (defaultName ? defaultName.length <= 2 : true) {
			//Inform the user that we need a min length
			addNotification({
				type: 'info',
				message: $_('settings.basic.document_labels.lbl_name_length')
			});
			return;
		}

		try {
			//Start to create the resource.
			await store.createSettingPaymentPeriodStore(defaultName);

			//Hide the modal again.
			onModalClose();
		} catch (error) {
			handleStoreError('settings.basic.payment_periods.err_create_payment_period', error);
		}
	}
</script>

<Modal {onModalClose} onModalEnter={createSettingDocumentType}>
	{#snippet header()}
		<ModalHeader text={$_('settings.basic.payment_periods.lbl_create_header')} />
	{/snippet}
	{#snippet content()}
		<div class="grid gap-2">
			<!--Name-->
			<InputLabel label={$_('settings.basic.document_labels.lbl_name')} />
			<DefaultTextInput propertyName="" bind:value={defaultName} focusOnStart={true} />
		</div>
	{/snippet}

	{#snippet footer()}
		<div class="flex justify-end gap-4">
			<DefaultButton
				secondary={true}
				text={$_('general.bt_close')}
				onClick={() => {
					onModalClose;
				}}
			/>
			<DefaultButton text={$_('general.lbl_create')} onClick={createSettingDocumentType} />
		</div>
	{/snippet}
</Modal>
